"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notJsonError = exports.emptyBodyError = exports.notOkError = exports.responseTemplate = void 0;
const SCOPE = '@c3po';
class BaseError extends Error {
    constructor(name, args) {
        super(args);
        if (Error.captureStackTrace)
            Error.captureStackTrace(this, BaseError);
        this.name = name;
    }
}
class NotOkError extends BaseError {
    constructor(args) {
        super(`NotOkError ${SCOPE}`, args);
    }
}
class EmptyBody extends BaseError {
    constructor(args) {
        super(`EmptyBody ${SCOPE}`, args);
    }
}
class NotJson extends BaseError {
    constructor(args) {
        super(`NotJson ${SCOPE}`, args);
    }
}
const responseTemplate = ({ status, statusText }) => `${status} ${statusText}`;
exports.responseTemplate = responseTemplate;
const notOkError = (response) => new NotOkError((0, exports.responseTemplate)(response));
exports.notOkError = notOkError;
const emptyBodyError = (body) => new EmptyBody(`body is empty: ${JSON.stringify(body)}`);
exports.emptyBodyError = emptyBodyError;
const notJsonError = (contentType) => new NotJson(`invalid content type (${contentType})`);
exports.notJsonError = notJsonError;
